import { baseApi } from "./api";
import type { ContentSyncOptions, ContentSyncResult, ContentSyncPreviewResult } from "@nicsmith/shared_types";

export const contentSyncApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    syncContent: builder.mutation<ContentSyncResult, ContentSyncOptions>({
      query: (body) => ({
        url: "/admin/content-sync",
        method: "POST",
        body,
        timeout: 300000, // 5 min timeout for large syncs
      }),
      invalidatesTags: ["AdminStats", "Course", "Courses", "Module", "Exercise", "Category"],
    }),
    previewContentSync: builder.mutation<ContentSyncPreviewResult, ContentSyncOptions>({
      query: (body) => ({
        url: "/admin/content-sync/preview",
        method: "POST",
        body,
        timeout: 300000,
      }),
    }),
  }),
  overrideExisting: true,
});

export const { useSyncContentMutation, usePreviewContentSyncMutation } = contentSyncApi;
